module.exports = __webpack_public_path__ + "static/ngps-shadow-anim-7e7501577088e3f5a782521e1493dc52.gif";